/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard components
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";

import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getRejectedTop10,
  getSubModulesByRoleId,
} from "../../../../store";

// config file
import Config from "../../../../config/index";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const RejectedTop10 = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getRejectedTop10,
  getDynamicColumnReducer,
  getRejectedTop10Reducer,

  createDynamicColumn,
  getDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  useEffect(() => {
    getRejectedTop10(jwtToken);
  }, []);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let itemStatusReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "f925ea16-d94d-44e6-83ca-8ca0ba2840c0",
  );

  let viewItemStatus = itemStatusReportModule
    ? itemStatusReportModule.actionId.includes(
        "e7b51078-d27b-4bf2-9707-efa327848bad",
      )
    : null;

  const [state, setState] = useState({
    columns: [
      { Header: "category Code", accessor: "categoryCode" },
      { Header: "Item Code", accessor: "itemCode" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },

      { Header: "Control Type", accessor: "controlType" },
      { Header: "movement Type", accessor: "movementType" },
      { Header: "total Rejections", accessor: "totalRejections" },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempRejectedTop10 = [];
    let data = getRejectedTop10Reducer.rejectedTop10.data
      ? getRejectedTop10Reducer.rejectedTop10.data
      : [];

    setLoading(getRejectedTop10Reducer.loading);
    data?.map((RejectedTop10) => {
      let des = RejectedTop10?.itemDescription;
      let len = desLength;
      const formatDate = new Date(RejectedTop10.cd);
      const dailyVendorObject = {
        itemCode: RejectedTop10.itemCode,
        itemCode: `${RejectedTop10.itemCode}`,
        itemDescDownload: `${RejectedTop10.itemDescription}`,

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {RejectedTop10?.itemDescription?.length > 35 ? (
              <Tooltip
                title={RejectedTop10.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {RejectedTop10.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {RejectedTop10.itemDescription}
              </MDTypography>
            )}
            {RejectedTop10?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),
        controlType:
          (RejectedTop10.controlType === 0 && `No Control`) ||
          (RejectedTop10.controlType === 1 && `Serial Control`) ||
          (RejectedTop10.controlType === 2 && `Lot Control`),
        categoryCode: RejectedTop10.categoryCode,
        movementType: RejectedTop10.movementType,
        totalRejections: RejectedTop10.totalRejections,
      };
      tempRejectedTop10.push(dailyVendorObject);
    });
    // viewFG &&
    setState({ ...state, rows: tempRejectedTop10 });
  }, [getRejectedTop10Reducer]);

  const headers = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "itemDesc",
      key: "itemDescDownload",
    },
    { label: "categoryCode", key: "categoryCode" },
    { label: "controlType", key: "controlType" },
    { label: "qty", key: "qty" },
  ];

  const csvLink = {
    filename: "Item Status Report.csv",
    headers: headers,
    data: rows,
  };

  const subModuleId = "f925ea16-d94d-44e6-83ca-8ca0ba2840c0";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getRejectedTop10(jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <>
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <Card> */}
            <MDBox
              display="flex"
              flexDirection={{ xs: "column", lg: "row" }}
              justifyContent="space-between"
              alignItems="center"
              p={3}
              mb={-3}
              mt={-4}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} lg={8}>
                  <MDBox
                    display="flex"
                    flexDirection={{ xs: "column", lg: "row" }}
                    mt={2}
                  ></MDBox>
                </Grid>
              </Grid>
            </MDBox>
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox pt={3}>
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                showTotalEntries={true}
                noEndBorder
                loading={loading}
                hideColumns={hiddenColumsDetails}
                visibleColumns2={dynamicColumnData?.visibleFields}
                dynamicColumnData={dynamicColumnData}
                handleOpenCreateColumnReorderModal={
                  handleOpenCreateColumnReorderModal
                }
                subModuleId={subModuleId}
                userId={userId}
              />
            </MDBox>
            {/* </Card> */}
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,

    getRejectedTop10Reducer: state.getRejectedTop10Reducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getRejectedTop10: (jwtToken) => dispatch(getRejectedTop10(jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(RejectedTop10);
